import get from 'lodash.get';

export default class LaneInfo {
  constructor(laneInfo, auctionEulaAccepted) {
    this.laneInfo = laneInfo || {};
    this.auctionEulaAccepted = auctionEulaAccepted ?? false;
  }

  get allowBidding() {
    return this.laneInfo.allow_bidding;
  }

  get allowScheduledAuctions() {
    return this.laneInfo.allow_scheduled_auctions;
  }

  get canBid() {
    return this.laneInfo.can_bid;
  }

  get canBuy() {
    return this.laneInfo.can_buy;
  }

  get canMakeOffer() {
    return this.laneInfo.can_make_offer;
  }

  get canProxyBid() {
    return this.laneInfo.can_proxy_bid;
  }

  get canPurchaseNow() {
    return this.laneInfo.can_purchase_now;
  }

  get canRemoveReserve() {
    return this.laneInfo.can_remove_reserve;
  }

  get hideAcvMaxRetailPriceVdp() {
    return get(this.laneInfo, 'hide_acv_max_retail_price_vdp', true);
  }

  get hideAcvEstimateVdp() {
    return get(this.laneInfo, 'hide_acv_estimate_vdp', false);
  }

  get hideBidsViewsVdp() {
    return get(this.laneInfo, 'hide_bids_views_vdp', false);
  }

  get isMultifunctionalBidding() {
    return this.laneInfo.is_multifunctional_bidding;
  }

  get displayName() {
    return this.laneInfo.lane_display_name;
  }

  get id() {
    return this.laneInfo.lane_id;
  }

  get permissionType() {
    return this.laneInfo.lane_permission_type;
  }

  get phase() {
    return this.laneInfo.lane_phase;
  }

  get makeOfferEndTime() {
    return this.laneInfo.make_offer_end_time;
  }

  get previewShowStartPrice() {
    return this.laneInfo.preview_show_start_price;
  }

  get purchaseNowEnabled() {
    return this.laneInfo.purchase_now_enabled;
  }

  get showReserve() {
    return this.laneInfo.show_reserve;
  }

  get eulaAccepted() {
    return this.auctionEulaAccepted;
  }
}
